"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Error class with error-code.
 */
class NekostoreError extends Error {
    constructor(code, message, original) {
        super(`${message}:${code}`);
        this.code = code;
        this.message = message;
        this.original = original;
    }
    get stack() {
        return (this.original && this.original.stack) || this.stack;
    }
}
exports.default = NekostoreError;
//# sourceMappingURL=NekostoreError.js.map